import * as actions from './actions';
import * as t from './tracking';

export default function({ getState }) {
  return next => action => {
    const state = getState();
    switch (action.type) {
      case actions.COLLECTION_ADDED:
        if (state.isCollectionSavingRequest) {
          t.collectionAdded(state.collectionsPending[0]);
        }
        break;
      case actions.SAVE_CART_SUCCESS:
        t.cartContentsChanged(state.currentOrder, action.order, state);
        break;
    }
    return next(action);
  };
}



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/tracking-middleware.js